
export const requestConfig = {
  oauth: {
    method: 'post',
    path: '/oauth',
    contentType: 'application/json',
  },
  forgotPassword: {
    method: 'post',
    path: '/forgot-password',
    contentType: 'application/json',
  },
  recoverPassword: {
    method: 'post',
    path: '/forgot-password/recover',
    contentType: 'application/json',
  },
  refreshToken: {
    method: 'post',
    path: '/refresh-token',
    contentType: 'application/json',
  },
  activateAccount: {
    method: 'post',
    path: '/activate-account',
    contentType: 'application/json',
  },
  me: {
    method: 'get',
    path: '/user/me',
    contentType: 'application/json',
  },
  getAllProjects: {
    method: 'get',
    path: '/project',
    contentType: 'application/json',
  },
  getAllProjectsWithFilter: {
    method: 'post',
    path: '/project/filter',
    contentType: 'application/json',
  },
  addEmployee: {
    method: 'post',
    path: '/user',
    contentType: 'application/json',
  },
  getAllEmployee: {
    method: 'get',
    path: '/user',
    contentType: 'application/json',
  },
  updateEmployee: {
    method: 'put',
    path: '/user/',
    contentType: 'application/json',
  },
  deleteEmployee: {
    method: 'delete',
    path: '/user/',
    contentType: 'application/json',
  },
  changeEmployeeStatus: {
    method: 'put',
    path: '/user/',
    contentType: 'application/json',
  },
  addCustomerUser: {
    method: 'post',
    path: '/customer/',
    contentType: 'application/json',
  },
  getCustomerUser: {
    method: 'get',
    path: '/customer/',
    contentType: 'application/json',
  },
  deleteCustomerUser: {
    method: 'delete',
    path: '/customer/',
    contentType: 'application/json',
  },
  addCustomer: {
    method: 'post',
    path: '/customer',
    contentType: 'application/json',
  },
  addCustomerLogo: {
    method: 'post',
    path: '/customer/',
  },
  getAllCustomer: {
    method: 'get',
    path: '/customer',
    contentType: 'application/json',
  },
  updateCustomer: {
    method: 'put',
    path: '/customer/',
    contentType: 'application/json',
  },
  changeCustomerStatus: {
    method: 'put',
    path: '/customer/',
    contentType: 'application/json',
  },
  getAllProjectType: {
    method: 'get',
    path: '/project/types',
    contentType: 'application/json',
  },
  getProjectDocument: {
    method: 'get',
    path: '/project/',
    contentType: 'application/json',
  },
  deleteProjectDocument: {
    method: 'delete',
    path: '/project/',
    contentType: 'application/json',
  },
  changeStatusProjectDocument: {
    method: 'put',
    path: '/project/',
    contentType: 'application/json',
  },
  addProjectDocument: {
    method: 'post',
    path: '/project/',
  },
  addProject: {
    method: 'post',
    path: '/project',
    contentType: 'application/json',
  },
  getAllProject: {
    method: 'get',
    path: '/project',
    contentType: 'application/json',
  },
  updateProject: {
    method: 'put',
    path: '/project/',
    contentType: 'application/json',
  },
  getAllProjectDetails: {
    method: 'get',
    path: '/project/',
    contentType: 'application/json',
  },
  changeProjectStatus: {
    method: 'put',
    path: '/project/',
    contentType: 'application/json',
  },
  uploadMap: {
    method: 'post',
    path: '/project/',
  },
  editMap: {
    method: 'put',
    path: '/map/',
    contentType: 'application/json',
  },
  convertMap: {
    method: 'post',
    path: '/map/convertToJpeg',
  },
  replaceMap: {
    method: 'put',
    path: '/map/',
  },
  getMapList: {
    method: 'get',
    path: '/project/',
    contentType: 'application/json',
  },
  deleteFloorMap: {
    method: 'delete',
    path: '/map/',
    contentType: 'application/json',
  },
  resendInvitationMail: {
    method: 'get',
    path: '/user/',
    contentType: 'application/json',
  },
  addZone: {
    method: 'post',
    path: '/map/',
    contentType: 'application/json',
  },
  editZone: {
    method: 'put',
    path: '/map/',
    contentType: 'application/json',
  },
  getFirePartitionPositions: {
    method: 'get',
    path: '/firepartition/positions',
    contentType: 'application/json',
  },
  deleteZone: {
    method: 'delete',
    path: '/map/',
    contentType: 'application/json',
  },
  addFPDocs: {
    method: 'post',
    path: '/firepartition/',
  },
  deleteFirePartition: {
    method: 'delete',
    path: '/firepartition/',
    contentType: 'application/json',
  },
  deletePictures: {
    method: 'put',
    path: '/firepartition/',
    contentType: 'application/json',
  },
  addProjectMaterialsList: {
    method: 'post',
    path: '/project/',
    contentType: 'application/json',
  },
  getMaterialSpecifications: {
    method: 'get',
    path: '/firepartition/material-specifications/',
    contentType: 'application/json',
  },
  getMaterials: {
    method: 'get',
    path: '/firepartition/',
    contentType: 'application/json',
  },
  addMaterials: {
    method: 'post',
    path: '/firepartition/',
    contentType: 'application/json',
  },
  getProjectCostDetails: {
    method: 'get',
    path: '/project/',
    contentType: 'application/json',
  },
  updateCostPercentages: {
    method: 'put',
    path: '/project/',
    contentType: 'application/json',
  },
  updateOtherCosts: {
    method: 'put',
    path: '/project/',
    contentType: 'application/json',
  },
  archiveSingleProjectCost: {
    method: 'put',
    path: '/project/',
    contentType: 'application/json',
  },
  getAllFpForDocument: {
    method: 'get',
    path: '/project/',
    contentType: 'application/json',
  },
  linkFirePartition: {
    method: 'post',
    path: '/project/',
    contentType: 'application/json',
  },
  moveFirePartition: {
    method: 'put',
    path: '/firepartition/',
    contentType: 'application/json',
  },
  getStatusReportDetails: {
    method: 'get',
    path: '/firepartition/',
    contentType: 'application/json',
  },
  unlinkFirePartition: {
    method: 'post',
    path: '/project/',
    contentType: 'application/json',
  },
  getAvailableFPs: {
    method: 'post',
    path: '/project/',
    contentType: 'application/json',
  },
  getLinkedFPs: {
    method: 'get',
    path: '/project/',
    contentType: 'application/json',
  },
  moveBulkOfFirePartition: {
    method: 'put',
    path: '/firepartition/',
    contentType: 'application/json',
  },
  reportBreach: {
    method: 'put',
    path: '/firepartition/',
    contentType: 'application/json',
  },
  getHighQualityImage: {
    method: 'post',
    path: '/map/',
    contentType: 'application/json',
  },
  moveFirePartitions: {
    method: 'put',
    path: '/firepartition/',
    contentType: 'application/json',
  },
  reportBreachFp: {
    method: 'put',
    path: '/fpBreach/qrCode/',
  },
  getFPDetailsByQrCode: {
    method: 'post',
    path: '/fpBreach/details/',
  },
  reportBreachFpByQrCode: {
    method: 'put',
    path: '/fpBreach/report/',
  },
  restoreOldMap: {
    method: 'patch',
    path: '/map/',
  },
};
